export function newJournalAfterSubmitLogic(
  newEntryData,
  setCongratulatoryCardData,
  toggleModal,
  afterSubmitFunction,
  setParentModalState,
  setPageState,
) {
  if (!newEntryData?.endScreen?.message) {
    if (newEntryData?.sourceName === 'daily-play') {
      !!newEntryData?.coins &&
        setCongratulatoryCardData({
          showCard: true,
          data: {
            coins: newEntryData?.coins,
            completed: newEntryData?.completed,
            completedItemType: 'journal',
            itemData: newEntryData,
          },
        })
      toggleModal()
    } else {
      afterSubmitFunction ? afterSubmitFunction(toggleModal) : setParentModalState('user_journals')
    }
  } else {
    afterSubmitFunction ? afterSubmitFunction(toggleModal) : setPageState('endscreen')
  }
}
